import * as i0 from '@angular/core';
import { Injectable, Inject, NgModule } from '@angular/core';
import * as i4 from '@upr-web-primer/gds-common-utility';
import { GdsCommonUtilityModule } from '@upr-web-primer/gds-common-utility';
import { DOCUMENT } from '@angular/common';
import * as i1 from '@angular/common/http';
import * as i2 from '@upr-web-primer/locale';
import * as i3 from '@upr-web-primer/page-labels';
import { get, set } from 'lodash-es';
import moment from 'moment';
import { forkJoin } from 'rxjs';
import { take, catchError } from 'rxjs/operators';
class GdsTripAdvisorService {
  constructor(http, document, appDefaults, localeService, pageLabelsResolver, utility) {
    this.http = http;
    this.document = document;
    this.appDefaults = appDefaults;
    this.localeService = localeService;
    this.pageLabelsResolver = pageLabelsResolver;
    this.utility = utility;
    this.reviewList = [];
    this.taEnabled = this.appDefaults.TRIP_ADVISOR_ENABLED;
    const locale = this.localeService.getFromStorage();
    this.language = this.document.documentElement.lang || locale.language;
    moment.updateLocale(this.language, {
      week: {
        dow: 0,
        doy: 0
      }
    });
    this.pageLabelsResolver.get().then(pageLabels => {
      this.pageLabels = pageLabels;
    });
  }
  getLocationReviews(component) {
    const reviewType = get(component, 'data.ratingsReview.reviewType.Key') || get(component, 'data.ratingsReview.reviewType') || get(component, 'data.reviewSection.reviewType.Key') || get(component, 'data.reviewSection.reviewType') || get(component, 'reviewSection.reviewType.Key');
    const tripAdvisorId = get(component, 'data.ratingsReview.advisorUnq') || get(component, 'data.reviewSection.advisorUnq') || get(component, 'reviewSection.advisorUnq');
    if (tripAdvisorId && reviewType === 'trip-advisor') {
      this.getReviews(tripAdvisorId, component);
    }
  }
  getReviews(locationId, componentEl) {
    if (!this.taEnabled) return;
    forkJoin({
      simpleReview: this.getTripAdvisorData(locationId),
      fullReview: this.getFullReviews(locationId)
    }).pipe(take(1)).subscribe(({
      simpleReview,
      fullReview
    }) => {
      if (!simpleReview || !fullReview) return;
      this.reviewObj = Object.assign(simpleReview, {
        reviews: get(fullReview, 'data')
      });
      this.reviewList = [...this.reviewList, this.reviewObj];
      const componentData = get(componentEl, 'data') || componentEl;
      const openReviewsInModal = get(componentData, 'openReviewsinModal') || get(componentData, 'reviewSection.openReviewsinModal', 'false');
      const reviewSection = {
        rating: {
          mobile: simpleReview.rating_image_url,
          desktop: simpleReview.rating_image_url,
          tablet: simpleReview.rating_image_url,
          alt: `${simpleReview.rating} ${this.pageLabels['tripAdvisorAltText']}`,
          title: ''
        },
        reviewLink: {
          label: this.utility.formatNumbers(simpleReview.num_reviews) + ' ' + this.pageLabels['TripAdvisorReviews'],
          href: openReviewsInModal === 'true' ? '' : simpleReview.web_url,
          analytics: this.pageLabels['TripAdvisorSeeReviews'],
          ariaLabel: `${simpleReview.num_reviews + ' ' + this.pageLabels['TripAdvisorReviews']}`,
          target: openReviewsInModal === 'true' ? 'modal' : 'routeLink'
        },
        openReviewsInModal: openReviewsInModal === 'true',
        type: get(componentData, 'data.reviewSection.type')
      };
      set(componentData, 'reviewSection', reviewSection);
      if (!componentEl.data) {
        return componentData;
      } else {
        componentEl.data = {
          ...componentEl.data,
          data: componentData
        };
      }
    }, error => {
      console.error(this.pageLabels['txtReviewsError'], error);
    });
  }
  getTripAdvisorData(locationId) {
    const tripAdvisorApiUrl = `${this.appDefaults.TRIP_ADVISOR_API_URL}${locationId}`;
    return this.http.get(tripAdvisorApiUrl, {
      params: {
        key: this.appDefaults.TRIP_ADVISOR_API_KEY,
        lang: this.language
      }
    }).pipe(catchError(error => {
      throw new Error(this.pageLabels['txtReviewsError']`${error}`);
    }));
  }
  getFullReviews(locationId) {
    const tripAdvisorApiUrl = `${this.appDefaults.TRIP_ADVISOR_API_URL}${locationId}/reviews`;
    return this.http.get(tripAdvisorApiUrl, {
      params: {
        key: this.appDefaults.TRIP_ADVISOR_API_KEY,
        lang: this.language
      }
    }).pipe(catchError(error => {
      throw new Error(this.pageLabels['txtReviewsError']`${error}`);
    }));
  }
  /**
   * get review from list of trip-advisor response
   */
  getReview(locationId) {
    this.reviewList.forEach(review => {
      if (review.location_id === locationId) {
        this.reviews$ = review;
      }
    });
    return this.reviews$;
  }
  static {
    this.ɵfac = function GdsTripAdvisorService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GdsTripAdvisorService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(DOCUMENT), i0.ɵɵinject('AppDefaults'), i0.ɵɵinject(i2.LocaleService), i0.ɵɵinject(i3.PageLabelsResolver), i0.ɵɵinject(i4.GdsCommonUtilityService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: GdsTripAdvisorService,
      factory: GdsTripAdvisorService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GdsTripAdvisorService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.HttpClient
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: [DOCUMENT]
    }]
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: ['AppDefaults']
    }]
  }, {
    type: i2.LocaleService
  }, {
    type: i3.PageLabelsResolver
  }, {
    type: i4.GdsCommonUtilityService
  }], null);
})();
class GdsTripAdvisorModule {
  static {
    this.ɵfac = function GdsTripAdvisorModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GdsTripAdvisorModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: GdsTripAdvisorModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [GdsTripAdvisorService],
      imports: [GdsCommonUtilityModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GdsTripAdvisorModule, [{
    type: NgModule,
    args: [{
      imports: [GdsCommonUtilityModule],
      providers: [GdsTripAdvisorService]
    }]
  }], null, null);
})();

/*
 * Public API Surface of gds-trip-advisor
 */

/**
 * Generated bundle index. Do not edit.
 */

export { GdsTripAdvisorModule, GdsTripAdvisorService };
